import { DecisionTypes } from "../../enums/decision-types";

export interface OptimizePlanSignalRMessageRequest {
    decisionType: DecisionTypes;
    id: string;
    subject: string;
}